import React from 'react';
import type { IconProps } from '@mc/design-system';
/* istanbul ignore file */
// Two elements required: merging these styles onto one element makes currentColor in background resolve against its own color, rendering the glyph invisible.
const FILLED_STYLE: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  background: 'var(--cert-icon-circle, currentColor)'
};
const FILLED_INNER: React.CSSProperties = {
  display: 'flex',
  width: '64%',
  height: '64%',
  color: 'var(--cert-icon-fg, var(--c-beige-100, #FEFAF2))'
};
function IconHome({
  srText,
  size = 'md',
  className = '',
  filled,
  ...props
}: IconProps & {
  filled?: boolean;
}) {
  const sizeClassName = `mc-icon mc-icon--${size} ${className}`;
  const newClassName = filled ? '' : sizeClassName;
  const svg = <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="-5.6 -5.6 31.2 31.2" aria-hidden="true" role="img" className={newClassName} {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.667} d="M2.5 7.497 10 1.664l7.5 5.833v9.167a1.667 1.667 0 0 1-1.667 1.667H4.167A1.667 1.667 0 0 1 2.5 16.664z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.667} d="M7.5 18.333V10h5v8.333" /></svg>;
  if (filled) {
    return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<span className={sizeClassName} style={FILLED_STYLE}><span style={FILLED_INNER}>{React.cloneElement(svg, {
            style: {
              width: '100%',
              height: '100%',
              ...props.style
            }
          })}</span></span></>;
  }
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}{svg}</>;
}
export default IconHome;